import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getAccountGroupsShortInfo} from 'src/openapi/admin/apis/GetAccountGroupsShortInfoApi';
import {useAppDispatch} from 'src/store/hooks';

import {groupsTabStateSelector} from '../slices/groups-tab-state.slice';
import {
    groupsTabActions,
    groupsTabDataSelector,
    groupsTabResultSelector,
} from '../slices/groups-tab.slice';

import type {GroupsTabCacheKeys} from '../typedef';
import type {AccountGroupsPage} from 'src/openapi/admin/models/AccountGroupsPage';


export const useGetGroupsTab = () => {
    const queryParams = useParams<{accountId: string}>();
    const accountId = queryParams.accountId ? +queryParams.accountId : -1;

    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback((cacheKeys: GroupsTabCacheKeys) => apiDispatch(getAccountGroupsShortInfo({
        accountId,
        pageNumber: cacheKeys.pagination.currentPage,
        pageSize: cacheKeys.pagination.pageSize,
        searchByGroupName: cacheKeys.filters?.name as string | undefined,
        sortDirection: cacheKeys.sortCriteria.direction,
    })), [accountId, apiDispatch]);

    const setLoadedData = useCallback((
        response: AccountGroupsPage,
        cacheKeys: GroupsTabCacheKeys,
    ) => {
        dispatch(groupsTabActions.onSuccess(({
            cacheKeys,
            data: response.groups,
            totalCount: response.totalCount,
        })));
    }, [dispatch]);

    return useCachedTable({
        dataSelector: groupsTabDataSelector,
        stateSelector: groupsTabStateSelector,
        resultSelector: groupsTabResultSelector,
        actions: groupsTabActions,
        getAction,
        onSuccessLoad: setLoadedData,
    });
};
